<template>
  <div id="survey-list">
    <b-card no-body class="p-2 container-card">
      <b-row>
        <b-col cols="12">
          <div class="d-flex justify-content-between text-black">
            <div
              class="d-flex justify-content-center align-item-center font-large-1 font-weight-bolder"
            >
              Survey List
            </div>
            <div class="d-flex align-items-end">
              <div class="mr-1 ml-1 mb-1">
                <div class="font-medium-4">Status</div>
                <v-select
                  id="campaign-type-status"
                  v-model="formStatus.status"
                  class="v-select-filter bg-document-list bg-dropdown"
                  :class="formStatus.status ? 'v-select-filter-selected' : null"
                  placeholder="Status"
                  :options="statusOption"
                  @input="(option) => onSelectFilter('status', option)"
                />
              </div>
              <div class="search-container mr-1 ml-1 mb-1">
                <div class="font-medium-4">search</div>
                <search :on-search-input="onSetValueSearch" class="w-100" />
              </div>
              <div class="mr-1 ml-1 mb-1">
                <add-button
                  v-if="getPermissionModule('Survey and Quiz').adjust"
                  isIconPlus
                  :btn-label="'Survey'"
                  @click.native="onCreateSurvey"
                />
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <!-- <b-table
                :fields="fields"
                :items="surveyListTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table text-center"
              > -->
              <b-table
                :fields="fields"
                :items="surveyListTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table-vertical text-center"
              >
                <template #cell(seq)="data">
                  <span>{{ data.index + 1 }}</span>
                </template>
                <template #cell(cover_image_url)="data">
                  <div class="d-flex justify-content-center">
                    <img
                      :src="data.item.cover_image_url || DefaultImg"
                      class="image-column"
                    />
                  </div>
                </template>
                <template #cell(valid_from)="data">
                  <span>{{
                    resolveDateWithSeperator(data.item.valid_from)
                  }}</span>
                </template>
                <template #cell(valid_through)="data">
                  <span>{{
                    resolveDateWithSeperator(data.item.valid_through)
                  }}</span>
                </template>
                <template #cell(updatedtime)="data">
                  <span>{{
                    resolveDateWithSeperator(data.item.updatedtime)
                  }}</span>
                </template>
                <template #cell(status)="data">
                  <b-form-checkbox
                    field-value="true"
                    class="custom-control-success custom-toggle w-50px"
                    name="check-button"
                    switch
                    :checked="data.item.status == 1 ? true : false"
                    @change="onToggleStatus($event, data.item)"
                  >
                    <span class="switch-icon-left toggle-text">{{ "" }}</span>
                    <span class="switch-icon-right toggle-text">{{ "" }}</span>
                  </b-form-checkbox>
                </template>
                <template #cell(actions)="data">
                  <div v-if="getPermissionModule('Survey and Quiz').adjust" class="d-flex align-item-center justify-content-end">
                    <div
                      v-if="data.item.isdashborad"
                      class="dashboard-wrp mr-4"
                      @click="onOpenDashboard(data.item)"
                    >
                      <icon-dashboard
                        class="svg-icon iconEdit-btn"
                        v-b-tooltip.hover
                        title="Dashboard"
                      />
                    </div>
                    <action-group
                      class="ml-4 mr-4"
                      :resolve-action="resolveMappingTableAction"
                      :set-action-list="surveyActionList"
                      :item-data="data"
                    />
                  </div>
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import AddButton from "@/views/components/button/AddButton.vue";
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import OverlayLoading from "@/views/components/loading/OverlayLoading.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import EditIcon from "@/@core/components/svg/common/Edit.vue";
import DeleteIcon from "@/@core/components/svg/common/Trash.vue";
import ActionGroup from "@/views/components/table-action-group/ActionGroup.vue";
import IconDashboard from "@/@core/components/svg/common/IconDashboard.vue";
import useSurveyList from "@/views/pages/survey-quiz/survey-list/hooks/useSurveyList";
import DefaultImg from "@/assets/images/icons/no-img-square.jpg";

export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    AddButton,
    Search,
    vSelect,
    EditIcon,
    DeleteIcon,
    OverlayLoading,
    PaginationWithReorder,
    ActionGroup,
    IconDashboard,
  },
  setup() {
    const {
      loading,
      optionData,
      fields,
      statusOption,
      pagination,
      onPageChange,
      onFilterEntity,
      filters,
      ordering,
      onSetValueSearch,
      onSelectFilter,
      surveyListTable,
      resolveMappingTableAction,
      surveyActionList,
      onCreateSurvey,
      onToggleStatus,
      resolveDateWithSeperator,
      resolveTime,
      formStatus,
      onOpenDashboard,
      getPermissionModule
    } = useSurveyList();

    return {
      loading,
      optionData,
      fields,
      statusOption,
      pagination,
      onPageChange,
      onFilterEntity,
      filters,
      ordering,
      onSetValueSearch,
      onSelectFilter,
      surveyListTable,
      resolveMappingTableAction,
      surveyActionList,
      onCreateSurvey,
      onToggleStatus,
      resolveDateWithSeperator,
      resolveTime,
      formStatus,
      DefaultImg,
      onOpenDashboard,
      getPermissionModule
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/v-select.css";

#survey-list .w-50px {
  width: 50px;
}

#survey-list .v-select-filter {
  width: 130px !important;
  border-radius: 6px !important;
  height: 37px;
}

#survey-list .vs__open-indicator {
  margin-top: 0.15rem;
  fill: #6c8baf;
  color: #6c8baf;
}

#survey-list .v-select-filter > div {
  border-radius: 6px !important;
  height: 37px;
}

#survey-list .add-button {
  border-radius: 6px !important;
}

#survey-list .add-button svg {
  width: 13px;
}

#survey-list .default-static-table .image-column {
  max-width: 130px;
  max-height: 130px;
  object-fit: cover;
}

#survey-list .vs__selected-options {
  flex-wrap: nowrap !important;
}

#survey-list .dashboard-wrp {
  width: 35px;
  height: 35px;
  cursor: pointer;
}

#survey-list .dashboard-wrp:hover {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #e5f2ff;
}

#survey-list .default-static-table .dashboard-wrp:hover .svg-icon {
  transform: scale(1);
  fill: #2187ef !important;
}
</style>